































import Vue from 'vue'
import { extractTargetFields, range } from '@/utils/helper'
import PhotoNumberValidator, { Fields, FieldErrors } from '@/utils/validators/form/Event/PhotoSearch'
import Presenter, { IPresenter } from './presenter'
import Checkbox from '@/components/shared/atoms/Checkbox'

// Components
import FormWrapper from '@/components/shared/organisms/FormWrapper'
import FormBlock from '@/components/shared/molecules/Form/FormBlock'
import TextArea from '@/components/shared/atoms/TextArea'

// dataStream
import { setRecord } from '@/plugins/dataStream'
import { AlbumListSchema } from '@/types/dataStream'

// userAgent
import { userAgentDedicatedToDataStream, confirmDesignType, getDeviceType } from '@/plugins/userAgent'

interface IData {
  fields: Fields
  enableCheckFlg: { [key in keyof Fields]: boolean }
  inputValue: boolean
}

export default Vue.extend({
  components: {
    FormWrapper,
    FormBlock,
    TextArea,
    Checkbox
  },
  props: {
    eventId: {
      type: Number,
      required: true
    },
    devProps: {
      type: Object as () => {
        photoNumbersTooLong?: boolean
        photoNumbersInvalid?: boolean
        fullfilled?: boolean
      },
      default: null
    }
  },
  data(): IData {
    return {
      fields: {
        photoNumbers: ''
      },
      enableCheckFlg: {
        photoNumbers: false
      },
      inputValue: false
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        profileRepository: this.$profileRepository
      })
    },
    formErrors(): FieldErrors {
      const targetFields = extractTargetFields(this.fields, this.enableCheckFlg)
      return PhotoNumberValidator.validate(targetFields)
    },
    isFullfilled(): boolean {
      // TODO: 要改善
      const { photoNumbers } = this.fields
      if (photoNumbers === '') return false
      return true
    },
    canSubmit(): boolean {
      const hasErrors = Object.values(this.formErrors).some(field => field.length !== 0)
      return this.isFullfilled && !hasErrors
    }
  },
  watch: {
    'fields.photoNumbers': {
      immediate: true,
      handler(val: string) {
        if (!val) return
        this.fields = {
          ...this.fields,
          photoNumbers: this.transformHankaku(val)
        }
      }
    }
  },
  created() {
    const devProps = this.devProps
    if (devProps) {
      if (devProps.photoNumbersTooLong) {
        this.fields = {
          ...this.fields,
          photoNumbers: range(1, 61)
            .map(num => `${num}-${num}`)
            .join('\n')
        }

        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          photoNumbers: true
        }
      }
      if (devProps.photoNumbersInvalid) {
        this.fields = {
          ...this.fields,
          photoNumbers: 'hoge'
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          photoNumbers: true
        }
      }
      if (devProps.fullfilled) {
        this.fields = {
          ...this.fields,
          photoNumbers: '1\n2-3\n4'
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          photoNumbers: true
        }
      }
    }
  },
  methods: {
    enableCheck(str: keyof Fields) {
      this.enableCheckFlg[str] = true
    },
    enableAllChecks() {
      Object.keys(this.fields).forEach(field => this.enableCheck(field as keyof Fields))
    },
    // TODO: 将来的にutilsに移して共通化する
    transformHankaku(str: string) {
      const halfStr = str
        .replace(/[０-９]/g, s => {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
        })
        .replace(/[‐－―ー]/g, '-')
      return halfStr
    },
    search() {
      this.enableAllChecks()

      if (!this.canSubmit) return

      const { photoNumbers } = this.fields

      const photoNos = photoNumbers.split(/\n/).filter(n => n !== '')

      this.putRecordOfSearch()

      this.$router.push({ path: '/events/' + this.eventId + '/search', query: { photoNos } })
    },
    putRecordOfSearch() {
      // profile情報がnullの場合、returnする
      if (this.presenter.profile === null) return
      // data stream 用のパラメータを設定
      const kinesisData: AlbumListSchema = {
        event_type: 'photonum_search',
        event_id: this.eventId,
        member_id: this.presenter.profile.props.id,
        ts: new Date().getTime(),
        design_type: confirmDesignType(),
        device_type: getDeviceType(),
        ...userAgentDedicatedToDataStream
      }

      // put record の実行
      setRecord(kinesisData, this.presenter.profile.props.id)
    }
  }
})
